import { Delete, Edit } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import ConfirmDeleteModalWindow from 'app/shared-components/confirmDeleteModalWindow';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getAbsoluteFileUrl, normalizeFIO } from 'src/app/helpers/utils';

const TopManager = ({ manager, onEdit, onRemove }) => {
  const { t } = useTranslation('translations');
  const [isOpenedModal, setIsOpenedModal] = useState(false);

  const handleEditTop = () => {
    onEdit(manager);
  };

  const handleRemoveTop = () => {
    onRemove(manager);
  };

  const handleShowModal = () => {
    setIsOpenedModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenedModal(false);
  };

  return (
    <div className="flex flex-col justify-between w-[260px] gap-16 min-h-[340px] p-10 py-24 rounded-md bg-white dark:bg-dark shadow-sm hover:shadow-md relative">
      <div className="flex flex-col items-center ">
        <div className="absolute top-6 right-2">
          <Edit className="text-[#2196f3] mr-6 cursor-pointer" onClick={handleEditTop} />
          <Delete onClick={handleShowModal} className="text-red cursor-pointer" />
        </div>
        <Avatar
          src={getAbsoluteFileUrl(manager?.managerImage)}
          variant="rounded"
          sx={{ width: 130, height: 160 }}
        />
        <div className="text-20 text-center mt-6">
          {manager.managerName ? normalizeFIO(manager.managerName) : ''}
        </div>
        <div className="text-center">{manager.top?.position}</div>
      </div>
      <div className="min-h-[60px]">
        {t('Secretary')}:
        {manager?.secretaryId ? (
          <div className="flex gap-10 mt-6 items-center">
            <Avatar src={getAbsoluteFileUrl(manager?.secretaryImage)} />
            <div>
              <div>{manager?.secretaryName ? normalizeFIO(manager.secretaryName) : ''}</div>
            </div>
          </div>
        ) : (
          <div className="h-full flex items-center justify-center text-red">{t('NotAssigned')}</div>
        )}
      </div>
      {isOpenedModal && (
        <ConfirmDeleteModalWindow
          onClose={handleCloseModal}
          setIsOpenModal={setIsOpenedModal}
          modalTitle={'AreYouSureToDeleteTopManager'}
          deleteMessage={handleRemoveTop}
          open={isOpenedModal}
        />
      )}
    </div>
  );
};

export default TopManager;
